/**
 * CKC Scent Detection entry form Division.
 *
 * The official entry form prints "Division: Small (less than 13 inches) / Medium (13 inches
 * to less than 20 inches) / Large (20 inches and above)". The band is derived from the dog's
 * height at the withers in inches and never stored.
 */
export const CKC_SCENT_DIVISION_SMALL = "Small";
export const CKC_SCENT_DIVISION_MEDIUM = "Medium";
export const CKC_SCENT_DIVISION_LARGE = "Large";

export const CKC_SCENT_DIVISION_MEDIUM_MIN_INCHES = 13;
export const CKC_SCENT_DIVISION_LARGE_MIN_INCHES = 20;

/** Division band for a withers height in inches, or undefined when the height is unknown. */
export const getCkcScentDivision = (heightAtWithers?: number | null): string | undefined => {
  if (heightAtWithers === undefined || heightAtWithers === null || isNaN(heightAtWithers)) {
    return undefined;
  }
  if (heightAtWithers < CKC_SCENT_DIVISION_MEDIUM_MIN_INCHES) return CKC_SCENT_DIVISION_SMALL;
  if (heightAtWithers < CKC_SCENT_DIVISION_LARGE_MIN_INCHES) return CKC_SCENT_DIVISION_MEDIUM;
  return CKC_SCENT_DIVISION_LARGE;
};
